import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Marquee from "react-fast-marquee";
import Buttons from "../components/Buttons";
import { TbWorldSearch } from "react-icons/tb";
import { GrDatabase } from "react-icons/gr";
import { FaRankingStar } from "react-icons/fa6";
import { RiFolderTransferLine } from "react-icons/ri";
import bannerVideo from "../assest/video/bannervideo.mp4";
import { useNavigate } from "react-router";
import { useModal } from "../context/ModalContext";


const Home = () => {
  const navigate = useNavigate();
  const { setShowModal } = useModal();
  return (
    <>
      <section>
        <div className="pad_90">
          <Container>
            <Row>
              <Col lg="7" xs="12" className=" py-5">
                <div className="banner-text">
                  Empowering Businessess with Data Driven Success
                </div>
              </Col>
              <Col lg="5" xs="12" className="py-5 align-self-center">
                <p className="monts-regular">
                  At SK Data Tech, we are dedicated to providing highly
                  accurate, data-driven solutions that empower businesses across
                  industries
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* service content start */}
      <section>
        <div>
          <Container fluid>
            <Row>
              <Col xs="12" className="py-3">
                <div className="text-center">
                  <video controls>
                    <source src={bannerVideo} type="video/mp4" />
                  </video>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* service content end */}
      {/* service content start */}
      <section>
        <div className="pad_90">
          <Container fluid>
            <Row>
              <Col xs="5" className="py-3 align-self-center">
                <div className="pot_point">
                  <img
                    src={require("../assest/images/funnel.png")}
                    alt="lead"
                    className="img-fluid"
                  />
                </div>
              </Col>
              <Col lg="7" xs="12" className="py-3">
                <div className="pot_point_text">
                  <p className="monts-regular">
                    "Turning potential leads into business opportunities
                    successfully."
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* service content end */}
      {/* leads content start */}
      <section>
        <div className="pad_90">
          <Container fluid>
            <Row>
              <Col lg="6" xs="12" className="py-3 align-self-center">
                <h1>From raw data to revenue</h1>
              </Col>
              <Col lg="6" xs="12" className="py-3 align-self-center text-end">
                <Buttons btnLabel="Read More" className="get-start" />
              </Col>
              <Col lg="4" className="py-3">
                <div className="serv-img">
                  <img
                    src={require("../assest/images/B2B-Lead-Generation-Data-Research-Solutions.webp")}
                    alt="lead"
                    className="img-fluid"
                  />
                  <div className="service-text">
                    <h5 className="monts">
                      B2B Lead Generation & Data Research Solutions
                    </h5>
                    <p className="monts-regular">
                      We specialize in high-quality, accurate, and targeted B2B
                      lead generation services tailored to your industry needs
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg="4" className="py-3">
                <div className="serv-img">
                  <img
                    src={require("../assest/images/Enriched-Databases-Data-Validation.webp")}
                    alt="lead"
                    className="img-fluid"
                  />
                  <div className="service-text">
                    <h5 className="monts">
                      Enriched Databases & Data Validation
                    </h5>
                    <p className="monts-regular">
                      Having access to accurate and up-to-date data is critical
                      for successful marketing and sales operations
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg="4" className="py-3">
                <Row>
                  <Col xs="12">
                    <div className="service-img mb-4 serv-img">
                      <img
                        src={require("../assest/images/Web-Research-Data-Mining.webp")}
                        alt="lead"
                        className="img-fluid"
                      />
                      <div className="service-text">
                        <h5 className="monts">Web Research & Data Mining</h5>
                      </div>
                    </div>
                  </Col>
                  <Col xs="12" className="mt-1">
                    <div className="service_img serv-img">
                      <img
                        src={require("../assest/images/Custom-Lead-Generation-Opt-in-Email-Lists.webp")}
                        alt="lead"
                        className="img-fluid"
                      />
                      <div className="service-text">
                        <h5 className="monts">
                          Custom Lead Generation & Opt-in Email Lists
                        </h5>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs="12" className="py-3">
                <div className="serv-img mobile-img">
                  <img
                    src={require("../assest/images/List-Building-List-Research.webp")}
                    alt="lead"
                    className="img-fluid"
                  />
                  <div className="service-text">
                    <h5 className="monts">List Building & List Research</h5>
                    <p className="monts-regular">
                      Our expert team specializes in curating high-quality,
                      conversion-driven business lists that support marketing
                      and sales efforts
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* leads content end */}
      {/* intro content start */}
      <section className=" pad_90">
        <div className="bg-two">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Marquee speed={70} gradient={false} direction="rigt">
                  <div>
                    <span className="marquee_span">Convert</span>
                    <span className="marquee_span">Find</span>
                    <span className="marquee_span">Connect</span>
                  </div>
                </Marquee>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      {/* intro content start */}
      {/* why choose us start */}
      <section>
        <Container fluid className="px-lg-4 px-md-5 px-sm-3 px-2 ">
          <Row>
            <Col xs="12">
              <div className="navbar_bg vision_point">
                <Row>
                  <Col lg="6" className="py-3">
                    <p className="vision_text">
                      Beyond Data – Building Opportunities
                    </p>
                    <div className="vision_img">
                      <img
                        src={require("../assest/images/Beyond-Data-–-Building-Opportunities.webp")}
                        alt="lead"
                        className="img-fluid"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="py-3">
                    <div className="vision_title mb-4">
                      <p>SK Data Tech</p>
                    </div>
                    <div className="monts">
                      <p>
                        Specializing in B2B lead generation, data mining, and
                        research, we help companies access verified and enriched
                        databases for smarter decision-making.
                      </p>
                    </div>
                    <div className="mt-5">
                      <Buttons btnLabel="Read More" className="get-start" />
                    </div>
                  </Col>
                  <Col lg="6"></Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="pad_90 ">
        <Container>
          <Row>
            <Col lg="5" xs="12" className="py-3 align-self-center">
              <p className="vision_text">Turning Data into Business Power</p>
            </Col>
            <Col lg="7" xs="12" className="py-3 align-self-center">
              <div className="text-lg-end text-center">
                <Buttons btnLabel="Read More" className="get-start" />
              </div>
            </Col>
            <Col lg="3" xs="12" className="py-3">
              <div className="why_choose">
                <div className="icon-gradient">
                  <TbWorldSearch className="why_choose_icon" />
                </div>
                <div className="why_choose_title">
                  <h4 className="bold">Unmatched Data Accuracy</h4>
                </div>
                <div className="why_choose_text">
                  <p className="monts-regular">
                    Our databases undergo rigorous validation, frequent updates,
                    and continuous enrichment to maintain the highest standards
                    of accuracy, relevance, and reliability.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="3" xs="12" className="py-3">
              <div className="why_choose">
               <div className="icon-gradient">
                  <RiFolderTransferLine className="why_choose_icon" />
                </div>
                <div className="why_choose_title">
                  <h4 className="bold">Comprehensive B2B Solutions</h4>
                </div>
                <div className="why_choose_text">
                  <p className="monts-regular">
                    We specialize in comprehensive data intelligence solutions
                    that empower your marketing and sales teams with actionable
                    insights.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="3" xs="12" className="py-3">
              <div className="why_choose">
               <div className="icon-gradient">
                    <GrDatabase className="why_choose_icon" />
                </div>
                <div className="why_choose_title">
                  <h4 className="bold">Real-Time Data Enrichment</h4>
                </div>
                <div className="why_choose_text">
                  <p className="monts-regular">
                    Stay ahead of the competition by leveraging real-time
                    updates and actionable insights that empower your business
                    to make data-driven decisions with precision.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="3" xs="12" className="py-3">
              <div className="why_choose">
               <div className="icon-gradient">
                  <FaRankingStar className="why_choose_icon" />
                
                </div>
                <div className="why_choose_title">
                  <h4 className="bold">
                    GDPR-Compliant & Ethical Data Practices
                  </h4>
                </div>
                <div className="why_choose_text">
                  <p className="monts-regular">
                    Maximize operational efficiency with intelligent automation
                    and streamlined workflows, enabling your team to focus on
                    innovation and strategic growth.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* why choose us end */}
    </>
  );
};

export default Home;
